import script from "./AddDentitionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDentitionModal.vue?vue&type=script&setup=true&lang=js"

import "./AddDentitionModal.vue?vue&type=style&index=0&id=4576361f&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4576361f"]])

export default __exports__